import {
  GET_ES_DOC_DETAILS_STARTED,
  GET_ES_DOC_DETAILS_SUCCESS,
  GET_ES_DOC_DETAILS_FAILURE,
  OP_FAVORITES_STARTED,
  OP_FAVORITES_COMPLETED,
  OP_BASKET_STARTED,
  OP_BASKET_COMPLETED,
} from "../constants/auth.constant";

import {
  OP_ALERT_STARTED,
  OP_ALERT_COMPLETED
} from "../constants/alerts.constant";

const initialState = {
  docStatus: { loading: false, error: null },
  favourite: { loading: false, error: null },
  basket: { loading: false, error: null },
  alert: { loading: false, error: null },
};

const updateDocStatus = (state, payload, key) => {
  let docStatus = state.docStatus;
  if (!payload) {
    docStatus = { ...state.docStatus, [`${key}`]: !state.docStatus[`${key}`] };
  }
  return docStatus;
};

export default function addToFavotitesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ES_DOC_DETAILS_STARTED:
      return {
        ...state,
        docStatus: {
          loading: true,
          error: null,
        },
      };
    case GET_ES_DOC_DETAILS_SUCCESS:
      return {
        ...state,
        docStatus: {
          loading: false,
          ...action.payload,
        },
      };
    case GET_ES_DOC_DETAILS_FAILURE:
      return {
        ...state,
        docStatus: {
          loading: false,
          error: action.payload,
        },
      };
    case OP_FAVORITES_STARTED:
      return {
        ...state,
        favourite: {
          loading: true,
          error: null,
        },
      };
    case OP_FAVORITES_COMPLETED:
      return {
        ...state,
        favourite: {
          loading: false,
          error: action.payload,
        },
        docStatus: updateDocStatus(state, action.payload, "isFavourite"),
      };
    case OP_BASKET_STARTED:
      return {
        ...state,
        basket: {
          loading: true,
          error: null,
        },
      };
    case OP_BASKET_COMPLETED:
      return {
        ...state,
        basket: {
          loading: false,
          error: action.payload,
        },
        docStatus: updateDocStatus(state, action.payload, "isBasket"),
      };

      case OP_ALERT_STARTED:
      return {
        ...state,
        alert: {
          loading: true,
          error: null,
        },
      };
    case OP_ALERT_COMPLETED:
      return {
        ...state,
        alert: {
          loading: false,
          error: action.payload,
        },
        docStatus: updateDocStatus(state, action.payload, "isAlert"),
      };
    default:
      return state;
  }
}
